/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2024-04-26 10:40:15
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 17:38:18
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageIntelligentDataSecurityGateway.js
 * @Description: 智能数据安全网关
 */

import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageIntelligentDataSecurityGateway.less';

const structureData = [
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj1.png'),
        title: '应用侧敏感数据识别与梳理',
        text1: '痛点：对业务系统中敏感数据分布情况不清晰',
        text2: '通过主动探测和智能识别的方式，协助企业准确快速识别业务系统中的敏感数据和泄露风险点；对敏感数据进行分类分级、打标签。'
    },
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj2.png'),
        title: '应用侧敏感数据脱敏与访问控制',
        text1: '痛点：业务难改造，数据泄露事件频发',
        text2: '部署方式为反向代理，业务免改造即可通过脱敏、可逆脱敏等能力对敏感数据进行防护。也能通过访问控制能力，对用户异常行为进行监测和预警，避免敏感数据被合法人员非法使用。',
    },
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj3.png'),
        title: '水印及水印溯源',
        text1: '痛点：员工安全意识不足，截图拍照引发信息泄露',
        text2: '通过WEB、文件及图片水印，对截图拍照等数据泄漏行为起到威慑作用；基于身份水印码，精准追溯到数据泄漏者。',
    },
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/yewu-cj4.png'),
        title: '敏感数据访问实时监控审计',
        text1: '痛点：泄露事件难溯源难定责',
        text2: '通过全量记录访问行为日志，提供完整证据链路用于事后追溯，解决企业泄露事件难溯源难定责等问题。',
    },
];

const clientData = [
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/kehu-al1.png'),
        title: '金融行业案例',
        text: '面对金融机构数据安全的复杂挑战，我们通过脱敏和敏感行为管控对其Web业务（OA/ERP）进行防护，并利用金融行业分类分级模版对其敏感数据梳理并打标'
            + '签，不仅实现业务免改造即可保障数据安全，还提升了客户数据资产管理效率，支持金融客户在严格合规的同时保障业务稳定持续运行。'
    },
    {
        imgSrc: require('../../asset/image/pageIntelligentDataSecurityGateway/kehu-al2.png'),
        title: '医疗机构案例',
        text: '为解决医疗机构对敏感数据定义不明、特权账号管理混乱等痛点，本产品提供敏感资产梳理、数据分类分级及权限管控等能力，并在其CRM系统、营销系统及大'
            + '数据资源管理运行平台等内部系统配置水印，实现用户数据安全管理的智能化和规范化，助力客户兼顾业务发展与安全的平衡。'
    }
];

const PageIntelligentDataSecurityGateway = props => {
    const bannerInfo = props.bannerInfo || {};
    const learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};

    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={bannerInfo.urlText}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
                {bannerInfo.learnMore.length
                    ? bannerInfo.learnMore.length === 1
                        ? bannerInfo.nextIndex === '0'
                            ? (<a href={learnMoreItem.content} target="_blank"
                                className="compliance-btn compliance-btn-border">
                                {learnMoreItem.title}
                            </a>) : (<a
                                href={learnMoreItem.content}
                                target="_blank"
                                className="compliance-btn compliance-btn-border"
                            >
                                {learnMoreItem.title}
                            </a>) : (<div className={'about-tab'}>
                            <div className={'about-slide'}>
                                <ul>
                                    {
                                        learnMore.map((item, index) => {
                                            return <li key={index}>
                                                <a href={item.content} target={'_blank'}>{item.title}</a>
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={'tab-shadow'} />
                        </div>) : null}

            </div>
            <div className={'product-des'}>
                {bannerInfo.bannerNote}
            </div>

            <div>
                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="产品价值" />
                </div>
                <div className="saas-p-advantage">
                    {
                        bannerInfo.proinfoBox.map((item, index) => {
                            return (
                                <div key={index} className="saas-p-advantage-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.mobile_pic})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des">{item.content}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div>
                <div className={'product-mod'}>
                    <ProductTitle title={'产品功能'} />
                </div>
                <div className={'product-mod'}>
                    {
                        bannerInfo.profunBox.map((item, index) => {
                            return (
                                <div key={index} className={'profun-box mui-flex'}>
                                    <div className={'profun-box-icon'}>
                                        <div className={'star'}>
                                        </div>
                                    </div>
                                    <div className={'cell'}>
                                        <div className={'profun-box-title'}>{item.title}</div>
                                        <div className={'profun-box-des'}>{item.content}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="产品优势" />
                </div>
                <div>
                    {
                        [
                            {
                                title: '联动信通院',
                                content: '与信通院的分类分级产品联动，提高敏感数据识别的合规性，为客户提供符合行业高标准的安全防护。'
                            },
                            {
                                title: '数据可逆脱敏',
                                content: '支持数据可逆脱敏，允许将数据恢复至原始状态，能够在不牺牲安全性的前提下充分利用数据资源。'
                            },
                            {
                                title: '支持图片脱敏',
                                content: '采用Swin Transformer深度学习模型，实现了对图像数据中敏感元素如人脸、车牌号的高效脱敏。'
                            },
                            {
                                title: '丰富的水印能力',
                                content: '支持Web水印、文档和图片明暗水印，提升员工安全红线意识，并能通过水印码追溯并锁定泄密者。'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-app-solution-card">
                                    <div className="title">{item.title}</div>
                                    <div className="content">{item.content}</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'应用场景'} />
                </div>
                <div>
                    {
                        structureData.map(({imgSrc, title, text1, text2, imgWidth}, index) => {
                            return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                                <div
                                    className={'shadow'}
                                >
                                    <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                        <img
                                            src={imgSrc}
                                            alt={title}
                                        />
                                    </div>
                                </div>
                                <div className={'title'}>
                                    {title}
                                </div>
                                <div className={'text'}>
                                    {text1}
                                </div>
                                <div className={'text'}>
                                    {text2}
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>

            <div style={{marginTop: '1rem'}}>
                <div className={'product-mod'}>
                    <ProductTitle title={'客户案例'} />
                </div>
                <div>
                    {
                        clientData.map(({imgSrc, title, text, imgWidth}, index) => {
                            return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                                <div
                                    className={'shadow'}
                                >
                                    <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                        <img
                                            src={imgSrc}
                                            alt={title}
                                        />
                                    </div>
                                </div>
                                <div className={'title'}>
                                    {title}
                                </div>
                                <div className={'text'}>
                                    {text}
                                </div>
                            </div>;
                        })
                    }
                </div>
            </div>

            <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="相关产品" />
                </div>
                <div>
                    {
                        [
                            {
                                title: '智能威胁狩猎平台',
                                content: '智能威胁狩猎平台是百度融合大数据及AI技术，将多种安全能力整合所打造的开箱即用的智能安全产品，在为客户构建完整的纵深防御体系的同时，'
                                    + '通过强大的智能溯源系统识别攻击者身份，并结合实时数据和智能算法模型，辅助客户进行高级安全决策，赋能安全运维人员，为企业保驾护航。',
                                url: 'https://anquan.baidu.com/product/znwxsl'
                            },
                            {
                                title: 'DDoS攻击防护',
                                content: '具备超过1.5Tbps抗D能力，采用云防护模式，全业务支持TCP/UDP/HTTP/HTTPS。无论您的源站是在百度云、其他公有云，或自建/租赁的线下'
                                + 'IDC均可接入和使用，有效防御各类三到七层DDoS/ CC攻击，挽回因网站或业务服务中断造成的诸多损失。更多问题点击下方咨询，价格优惠 限时试用。',
                                url: 'https://anquan.baidu.com/product/ddos'
                            },
                            {
                                title: 'WEB应用防火墙',
                                content: '由国内专家Web安全专家组成的技术团队，为不同行业、不同规模的网站提供了革命性的云防护安全模式，彻底颠覆了过去单点部署WAF形式的被动防护，'
                                + '以网站替身的形式为网站拦截各种SQL注入、XSS跨站、网站挂马、篡改、拖库等黑客攻击，并做到实时更新防护策略，第一时间防御各种0day漏洞，有效保护用户源站安全。',
                                url: 'https://anquan.baidu.com/product/waf'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-app-solution-card">
                                    <div className="title">{item.title}</div>
                                    <div className="content">{item.content}</div>
                                    <a href={item.url} target="_blank" className="btn">了解详情</a>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageIntelligentDataSecurityGateway.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageIntelligentDataSecurityGateway;



// WEBPACK FOOTER //
// ./src/containers/product/pageIntelligentDataSecurityGateway.js